<template>
  <svg viewBox="0 0 64 64">
    <rect x="14" y="18" width="36" height="28" rx="12" />
    <rect x="26" y="8" width="12" height="10" rx="5" />
    <circle cx="26" cy="31" r="4" />
    <circle cx="38" cy="31" r="4" />
    <rect x="24" y="39" width="16" height="3" rx="1.5" />
    <path d="M8 29h6M50 29h6M23 46l-4 8M41 46l4 8" />
  </svg>
</template>

<script>
export default {
  name: "AssistantBotIcon",
};
</script>
